import { render, staticRenderFns } from "./DjVueRadioGroup.vue?vue&type=template&id=f956655a&scoped=true&"
import script from "./DjVueRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./DjVueRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f956655a",
  null
  
)

export default component.exports